import React from 'react';
import ReactDOM from 'react-dom';
import '../src/style.css';
import SearchMovies from './components/SearchMovies'

class Main extends React.Component {
  render() {
    return (
      <div className="container">
        <h1 className="title">Search Movies</h1>
        <SearchMovies />
      </div>
    );
  }
}

ReactDOM.render(<Main />, document.getElementById('root'));
